import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import api from "../services/api";

const RecentPayroll = () => {
  const [payrollData, setPayrollData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id: businessId } = useParams();

  useEffect(() => {
    // Fetch recent payroll data
    const fetchPayrollData = async () => {
      try {
        setLoading(true);
        const response = await api.get(`/payroll/recent/full/${businessId}`);
        setPayrollData(response.data);
      } catch (err) {
        setError(err.response?.data?.message || "An error occurred.");
      } finally {
        setLoading(false);
      }
    };

    fetchPayrollData();
  }, [businessId]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!payrollData || payrollData.length === 0) {
    return <div>No recent payroll records found.</div>;
  }

  return (
    <div>
      <h1>Recent Payroll Details</h1>
      {payrollData.map((row, index) => (
        <div key={index} className="payroll-record">
          <h2>Record {row.ID}</h2>
          <p><strong>Name:</strong> {row.NAME}</p>
          <p><strong>Gross Pay:</strong> ${row.GROSSPAY}</p>
          <p><strong>Net Pay:</strong> ${row.NET_PAY}</p>
          <p><strong>Start Date:</strong> {row.START_DATE}</p>
          <p><strong>End Date:</strong> {row.END_DATE}</p>
          <p><strong>Pay Date:</strong> {row.PAY_DATE}</p>
          <p><strong>Frequency:</strong> {row.FREQUENCY}</p>
          {/* Display all fields dynamically */}
          <h3>Other Details:</h3>
          <ul>
            {Object.keys(row).map((key) => (
              key !== "ID" && key !== "NAME" &&
              <li key={key}>
                <strong>{key}:</strong> {row[key] || "N/A"}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default RecentPayroll;
